import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType"


import { navigate } from "gatsby"

export const onRouteUpdate = ({ location }) => {
  const pathname = location.pathname;

  if (pathname.includes("blog") || pathname.includes("article")) {
    navigate("/", { replace: true });
  }
};